import { render, staticRenderFns } from "./EntityInvestments.vue?vue&type=template&id=42430488"
import script from "./EntityInvestments.vue?vue&type=script&lang=js"
export * from "./EntityInvestments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports